'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _BounceLoading = require('../BounceLoading');

var _BounceLoading2 = _interopRequireDefault(_BounceLoading);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(Button, _React$Component);

  function Button() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.setOnClick = function (onClick) {
      _this.overrideOnClick = onClick;
    }, _this.click = function () {
      return _this.onClick();
    }, _this.onClick = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.props.disabled || _this.props.loading || _this.state.loading)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              if (!_this.props.confirmText) {
                _context.next = 9;
                break;
              }

              if (!_this.state.confirm) {
                _context.next = 7;
                break;
              }

              _this.setState({ confirm: false });
              _context.next = 9;
              break;

            case 7:
              _this.setState({ confirm: true });
              return _context.abrupt('return');

            case 9:

              _this.setState({ loading: true });

              if (!_this.overrideOnClick) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return _this.overrideOnClick();

            case 13:
              _context.next = 18;
              break;

            case 15:
              if (!_this.props.onClick) {
                _context.next = 18;
                break;
              }

              _context.next = 18;
              return _this.props.onClick();

            case 18:
              if (_this.mounted) {
                _this.setState({ loading: false });
              }

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Button, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'getChildProps',
    value: function getChildProps() {
      var omitKeys = (0, _keys2.default)(Button.propTypes);
      return _omit2.default.apply(undefined, [this.props].concat((0, _toConsumableArray3.default)(omitKeys)));
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var classes = ['orion_button'];
      if (this.props.disabled) {
        classes.push('orion_disabled');
      } else if (this.props.loading || this.state.loading) {
        classes.push('orion_loading');
      } else if (this.props.danger) {
        classes.push('orion_danger');
      } else if (this.props.primary) {
        classes.push('orion_primary');
      }
      if (this.props.big) {
        classes.push('orion_big');
      }
      if (this.props.fullWidth) {
        classes.push('orion_fullWidth');
      }
      return classes.join(' ');
    }
  }, {
    key: 'renderText',
    value: function renderText() {
      if (this.state.confirm) return this.props.confirmText;
      return this.props.label || this.props.children;
    }
  }, {
    key: 'renderInner',
    value: function renderInner() {
      if (this.props.loading || this.state.loading) {
        return _react2.default.createElement(_BounceLoading2.default, null);
      }
      if (this.props.icon) {
        return _react2.default.createElement(
          'span',
          null,
          this.renderIcon(),
          this.renderText()
        );
      } else {
        return this.renderText();
      }
    }
  }, {
    key: 'renderIcon',
    value: function renderIcon() {
      var Icon = this.props.icon;
      if (!Icon) return;
      return _react2.default.createElement(Icon, { style: { marginRight: 10, position: 'relative', top: -1 } });
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      return _react2.default.createElement(
        'span',
        { className: this.getClassName(), style: this.props.style },
        this.renderInner()
      );
    }
  }, {
    key: 'renderLinkButton',
    value: function renderLinkButton() {
      return _react2.default.createElement(
        'a',
        this.getChildProps(),
        this.renderButton()
      );
    }
  }, {
    key: 'renderMain',
    value: function renderMain() {
      if (this.props.linkButton || this.props.href || this.props.to) {
        return this.renderLinkButton();
      } else {
        return _react2.default.createElement(
          'span',
          (0, _extends3.default)({ className: 'os_button_container' }, this.getChildProps(), { onClick: this.onClick }),
          this.renderButton()
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.tooltip) {
        return _react2.default.createElement(
          _Tooltip2.default,
          { content: this.props.tooltip },
          this.renderMain()
        );
      } else {
        return this.renderMain();
      }
    }
  }]);
  return Button;
}(_react2.default.Component), _class.propTypes = {
  tooltip: _propTypes2.default.string,
  to: _propTypes2.default.string,
  href: _propTypes2.default.string,
  linkButton: _propTypes2.default.bool,
  label: _propTypes2.default.any,
  children: _propTypes2.default.any,
  primary: _propTypes2.default.bool,
  danger: _propTypes2.default.bool,
  big: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  icon: _propTypes2.default.any,
  onClick: _propTypes2.default.func,
  confirmText: _propTypes2.default.node
}, _class.defaultProps = {
  linkButton: false,
  primary: false,
  danger: false,
  big: false,
  style: {},
  disabled: false,
  fullWidth: false
}, _temp2);
exports.default = Button;